import { render, staticRenderFns } from "./yuerbhanjie.vue?vue&type=template&id=92d5c02a&scoped=true&"
import script from "./yuerbhanjie.vue?vue&type=script&lang=js&"
export * from "./yuerbhanjie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92d5c02a",
  null
  
)

export default component.exports